import 'react-phone-input-2/lib/material.css'
import { FieldContainer } from '../functional'
import styled from '@emotion/styled'
import { color, font, size, space } from '../../styles'

import React from 'react'
import PI, { PhoneInputProps } from 'react-phone-input-2'

interface phoneNumberFieldProps {
   name: string
   label?: string
   placeholder?: string
   disabled?: boolean
   style?: React.CSSProperties
   highlight?: boolean
}
const PhoneNumberField: React.FC<phoneNumberFieldProps> = ({
   name,
   label,
   style,
   highlight,
   ...props
}) => {
   const ReactPhoneInput: React.FC<PhoneInputProps> = (PI as any).default || PI
   return (
      <FieldContainer name={name} highlight={highlight}>
         {({ helperText, error, ...fieldProps }) => {
            return (
               <Holder className={error ? 'error' : ''} style={style}>
                  <ReactPhoneInput
                     country={'us'}
                     {...fieldProps}
                     onChange={(value) => {
                        fieldProps.onChange({ target: { name, value } })
                     }}
                     inputProps={{
                        name,
                        ...props,
                     }}
                     specialLabel={label ?? ''}
                     disabled={props.disabled || fieldProps.disabled}
                  />
                  {error && <span className="error-text">{helperText}</span>}
               </Holder>
            )
         }}
      </FieldContainer>
   )
}
const Holder = styled.div`
   position: relative;
   width: 100%;
   ${font.regular};
   .react-tel-input {
      position: relative;
      &:disabled {
         cursor: pointer;
      }

      &:focus,
      &:active,
      &:focus-within {
         .form-control {
            border-color: ${color.green} !important;
            box-shadow: 0 0 0 1px ${color.green} !important;
         }
         .flag-dropdown {
            border-width: 2px;
            border-right-color: ${color.green} !important;
         }
         .special-label {
            color: ${color.green};
         }
      }
      &:hover {
         .flag-dropdown {
            border-right-color: ${color.black};
         }
         .form-control {
            border-color: ${color.black};
         }
      }

      .form-control {
         ${font.thin};
         border-radius: ${space.xs};
         transition: box-shadow 0.2s ease-in-out;
         width: 100%;
         padding-left: 76px;
         height: 56px;
      }
      .flag-dropdown {
         transition: border-color border-width 0.2s ease-in-out;
         border-right: 1px solid #ccc;
         padding-inline: 6px;
      }
      .special-label {
         ${font.thin};
         font-size: ${size.s};
         color: ${color.grayDark};
      }
   }
   &.error {
      .react-tel-input {
         .form-control {
            border-color: ${color.red} !important;
         }
         .flag-dropdown {
            border-right-color: ${color.red} !important;
         }
         .special-label {
            color: ${color.red};
         }
         &:focus,
         &:active,
         &:focus-within {
            .form-control {
               border-color: ${color.red} !important;
               box-shadow: 0 0 0 1px ${color.red} !important;
            }
            .flag-dropdown {
               border-width: 2px;
               border-right-color: ${color.red} !important;
            }
         }
      }
   }
   .error-text {
      padding: ${space.s};
      ${font.thin};
      font-size: 13px;
      color: ${color.red};
      font-weight: 300;
      font-size: 0.75rem;
      line-height: 1.66;
      text-align: left;
      margin-top: 3px;
      margin-right: 14px;
      margin-bottom: 0;
      margin-left: 14px;
   }
`

export default PhoneNumberField
